import React, { useState } from 'react';
import { ForgeIconButton, ForgeIcon } from '@tylertech/forge-react';
import { StorySaveAsDialog } from '../SaveAsDerivedReport/StorySaveAsDialog';

export function EditDerivedReportMetadata() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <ForgeIconButton dense onClick={() => setModalOpen(true)} aria-label="Edit derived report">
        <ForgeIcon name="edit" />
      </ForgeIconButton>
      <StorySaveAsDialog dialogOpen={modalOpen} onCloseDialog={() => setModalOpen(false)} isEditing={true} />
    </>
  );
}
